import { displayAdminsAccessConfig } from "./display-admins-access-config";
import { deleteHrAdmin } from "../../infrastructure/repository/company-repository";
import { showErrorMessage } from "../commons/show-error-message";
import { showSuccessMessage } from "../commons/show-success-message";
import { logError } from "../../infrastructure/log";
import { translate } from "../../infrastructure/translate/localization";

export async function removeAdminsAccess(email) {
  try {
    await deleteHrAdmin(email).then(() => displayAdminsAccessConfig());
    showSuccessMessage("Acceso eliminado correctamente");
  } catch (e) {
    logError(e, `Error to removeAdminsAccess ${email}`);
    showErrorMessage(translate("common-messages.basic-error-message"), true, e);
  }
}
